export default function normalizeUrl(value) {
    return value.toLowerCase().replace(/[^a-z0-9_.-]/gi, '');
}
